import React, { useMemo } from "react";
import styles from "./reports.module.scss";
import Input from "components/Input";
import Table from "components/Table";
import { contractorDocsColumns } from "./columns";

const data = [
    {
        employee: "Sachin narang",
        label: "Federal",
        jurisdiction: "FED",
        category: "Employee Tax Document",
        year: "2024",
        field_on: "Thursday, Jun, 2024",
    }
]

const ContractorTaxDocs = () => {
    const columns = useMemo(() => {
        return contractorDocsColumns();
    }, []);

    return (
        <div className={styles.contractorTaxDocsContainer}>
            <div className={styles.header}>
                <Input
                    type="date"
                    variant="flat"
                    style={{ minWidth: "300px" }}
                />
                <Input
                    placeholder="Search by Name, Email, or Id"
                    style={{ minWidth: "300px" }}
                />
            </div>
            <Table
                headers={columns}
                data={data}
                containerStyle={{
                    border: "none",
                    borderRadius: "0px"
                }}
            />
        </div>
    )
}

export default ContractorTaxDocs;